import { render, staticRenderFns } from "./Unsubscribes.vue?vue&type=template&id=7f5f0537&"
import script from "./Unsubscribes.vue?vue&type=script&lang=ts&"
export * from "./Unsubscribes.vue?vue&type=script&lang=ts&"
import style0 from "./Unsubscribes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports